import { POPULAR_TREATMENT_TERM_THRESHOLD_MAP } from './constants'

export const getTermMeetingPopularTreatmentTypesThreshold = (term, count) => {
  const threshold = POPULAR_TREATMENT_TERM_THRESHOLD_MAP[term]
  return threshold !== undefined && count >= threshold ? term : ''
}
